"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PromptInput = require("./PromptInput");
Object.keys(_PromptInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PromptInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PromptInput[key];
    }
  });
});